<template>
  <div v-if="campus" class="a11y-modal">
    <div class="title">
      <h2>A message from {{ campus.name }}</h2>
    </div>

    <div class="body">
      <div v-if="campus.messageForNewUserPrompt" >
        <p v-html="campus.messageForNewUserPrompt" />
      </div>
      <div v-else>
        <p>
          Your campus has no additional information for you at this time.
        </p>
      </div>
    </div>

    <div class="actions">
      <button type="button" @click="$modal.close()">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampusPoliciesModal',

  mounted() {
    this.campus = this.$store.getters.currentUser.school;
  },

  data(){
    return {
      campus: null
    }
  },
};
</script>

<style lang="scss" scoped>
h3.question {
  color: $black;
  font-family: Open Sans,sans-serif;
  font-size: 16px;
  margin: 20px 0 4px 0;
}
.a11y-modal div.title {
  padding: 10px 20px 10px 20px;
  border-bottom: 0px
}
div.body {
  margin: 0 24px 0 24px;
}
p {    
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 14px;
}
</style>